<template>
  <div class="flex flex-col items-start gap-[12px] w-fit">
    <div class="drop-shadow-[0px_1px_10px_rgba(0,0,0,0.1)]">
      <div
        v-if="!(this.profilePicture || this.form64Picture)"
        :class="[
          'flex items-center w-[84px] h-[84px] text-[#FFF] text-[40px] font-family-[\'aktiv-grotesk-medium\'] justify-center leading-loose rounded-full border-white border-[3px]',
          isGic ? 'bg-orange' : 'bg-lightblue',
        ]"
      >
        {{ name.charAt(0) }}
      </div>
      <img
        v-if="this.profilePicture || this.form64Picture"
        :src="imageURL"
        class="w-[84px] h-[84px] rounded-full border-white border-[3px]"
      />
    </div>
    <button
      :class="[
        'font-aktiv-grotesk-trial text-[16px] leading-[24px] text-left whitespace-nowrap',
        isGic ? 'text-orange' : 'text-lightblue',
      ]"
      @click="$refs.fileInput.click()"
    >
      {{ $t('copy.profilePage.addImage') }}
    </button>
    <input
      id="file-upload"
      ref="fileInput"
      type="file"
      accept="image/png, image/jpeg, image/gif"
      class="hidden"
      @change="openImagePreview"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    isGic: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filePreview: null,
      currentPicture: null,
    };
  },
  computed: {
    ...mapState('social', ['name', 'profilePicture', 'form64Picture']),
    imageURL() {
      return this.form64Picture ? this.form64Picture : this.profilePicture;
    },
  },
  methods: {
    openImagePreview() {
      this.filePreview = URL.createObjectURL(this.$refs.fileInput.files[0]);
      this.$store.commit('social/setSelectedPicture', this.filePreview);
      // Reset so re-selecting the same file still fires @change next time.
      this.$refs.fileInput.value = '';
      this.$router.push('/profile/crop');
    },
  },
};
</script>
